import React, { useEffect, useState } from 'react';
import Header from './header.jsx';
import Sidebar from './sidebar.jsx';
import { Button, Form, Input, Select, message } from 'antd';
import axios from 'axios';
import { useParams } from 'react-router-dom';

export const AddTransferForm = () => {
  const { id } = useParams(); // Get familyId from the URL
  const [provinces, setProvinces] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState(null);

  // Fetch province data on component mount
  useEffect(() => {
    const fetchProvinces = async () => {
      try {
        const response = await axios.get('https://ward3-chandrapur-api.palikaapp.com/api/province/all');
        setProvinces(response.data);
      } catch (error) {
        message.error('Failed to load provinces.');
      }
    };

    fetchProvinces();
  }, []);

  // Update districts based on selected province
  const handleProvinceChange = (provinceId) => {
    const selected = provinces.find((province) => province.id === provinceId);
    setSelectedProvince(selected);
    setDistricts(selected ? selected.districtDTOS : []);
  };

  // Handle form submission
  const handleSubmit = async (values) => {
    const payload = {
      isTransferred: values.isTransferred === 'yes',
      transferDate: values.date,
      provinceId: selectedProvince ? selectedProvince.id : null,
      districtId: values.district,
      familyId: id, // Use familyId from URL
    };

    try {
      const response = await axios.post('https://ward3-chandrapur-api.palikaapp.com/api/family-migration/save', payload);
      message.success('बसाइ सराइ सफलतापूर्वक सुरक्षित गरियो');
    } catch (error) {
      message.error('बसाइ सराइ सुरक्षित गर्न असफल भयो।');
    }
  };

  return (
    <div className="flex flex-col lg:flex-row min-h-screen bg-gray-100">
      {/* Sidebar */}
      <div className="lg:w-1/5">
      <Header />
        
      </div>

      {/* Main Content */}
      <div className="lg:w-4/5 p-6 pt-10">
      <Sidebar />
        
        <h1 className="text-xl lg:text-2xl font-bold mt-10 lg:mt-16 text-center lg:text-center">
          बसाइ सराइको फार्म
        </h1>
        <div className="flex justify-center mt-10">
          <Form
            onFinish={handleSubmit}
            className="w-full max-w-lg bg-white p-6 shadow-lg rounded-md"
            layout="vertical"
          >
            <Form.Item
              label="बसाइ सराइ गरेको हो?"
              name="isTransferred"
              rules={[{ required: true, message: 'कृपया चयन गर्नुहोस्' }]}
            >
              <Select className="border-gray-300 rounded-md">
                <Select.Option value="yes">हो</Select.Option>
                <Select.Option value="no">होइन</Select.Option>
              </Select>
            </Form.Item>

            <Form.Item
              label="प्रदेश"
              name="province"
              rules={[{ required: true, message: 'कृपया प्रदेश चयन गर्नुहोस्' }]}
            >
              <Select
                onChange={handleProvinceChange}
                className="border-gray-300 rounded-md"
              >
                {provinces.map((province) => (
                  <Select.Option key={province.id} value={province.id}>
                    {province.nameNep}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="जिल्ला"
              name="district"
              rules={[{ required: true, message: 'कृपया जिल्ला चयन गर्नुहोस्' }]}
            >
              <Select className="border-gray-300 rounded-md">
                {districts.map((district) => (
                  <Select.Option key={district.id} value={district.id}>
                    {district.nameNep}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="बसाइ सराइको मिति"
              name="date"
              rules={[{ required: true, message: 'कृपया मिति चयन गर्नुहोस्' }]}
            >
              <Input type="date" className="border-gray-300 rounded-md" />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="w-full bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-md"
              >
                सुरछित गर्नुहोस
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};
